import { SimpleForm,TextInput,ImageInput } from 'react-admin';
// TODO: custom image input pour fit avec le format ImageInput du schéma
export const UserEditInputs = (props:any) => (
    <SimpleForm onSubmit={props.userSave}>
        <TextInput label="Prénom" source="firstName" />
        <TextInput label="Nom de famille" source="lastName" />
        <TextInput type="email" label="Adresse Mail" source="email" />  
        <ImageInput label="Avatar" source="avatarImage" />        
    </SimpleForm>
)